import { useEffect } from 'react';

export const useFirewallServicesStatusData = getFirewallServicesStatusRequest => {
    useEffect(() => {
        const timer = setInterval(() => getFirewallServicesStatusRequest(), 3e4);

        return () => clearInterval(timer);
    }, []);
};
